import type { Consultation } from '@/hooks/patients/usePatientConsultations';
import { luxonFormatWithOrdinalSuffix } from '@/utils/luxon';
import { Typography } from '@montugroup/design-system';
import { Grid } from '@mui/material';
import { DateTime } from 'luxon';
import { getPractitionerName } from '../utils/getPractitionerName';

export interface ConsultDetailInfoProps {
  consultation: Consultation;
}

export const ConsultDetailInfo = ({ consultation }: ConsultDetailInfoProps) => {
  const practitioner = getPractitionerName({ doctor: consultation.Doctor, nurse: consultation.Nurse });

  const startDateTime = DateTime.fromISO(consultation.start_time || '');
  const endDateTime = DateTime.fromISO(consultation.end_time || '');
  const durationMins = consultation.ConsultationType.duration_mins;
  const appointmentTime = `${startDateTime.toFormat('MMM')} ${luxonFormatWithOrdinalSuffix(startDateTime.day)} ${startDateTime.toFormat('yyyy, h:mm a').toLowerCase()} - ${endDateTime.toFormat('h:mm a').toLowerCase()} (${durationMins} mins)`;

  return (
    <>
      <Typography component="h2" variant="h6" color="primary">
        {consultation.doctor_id ? 'Doctor Consultation' : 'Nurse Consultation'} ({consultation.consultation_code})
      </Typography>

      <Grid container spacing={2} marginTop={2}>
        <Grid item xs={6}>
          <Typography>Consultation Date/Time</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{appointmentTime}</Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography>Practitioner</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{practitioner}</Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography>Consult Status</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{consultation.ConsultationStatus?.name}</Typography>
        </Grid>
      </Grid>
    </>
  );
};
